import { useTemplateAndContentFrequencyManagementSettings } from 'modules/frequencyManagement/lib/hooks/useTemplateAndContentFrequencyManagementSettings';
import { useTemplateContext } from '../context';

const defaultState = {
  isIgnoreCapVisible: false,
  isIgnoreCapEditable: false,
};

type State = {
  isIgnoreCapVisible: boolean;
  isIgnoreCapEditable: boolean;
};

export const useIgnoreCapAvailability = (): State => {
  const { templateAndContent, isLoading: isLoadingTemplateAndContent } = useTemplateContext();

  const { isTemplateFrequencyManagementEligible, isTemplateFrequencyManaged } =
    useTemplateAndContentFrequencyManagementSettings(templateAndContent);

  if (isLoadingTemplateAndContent) return defaultState;

  return {
    isIgnoreCapVisible: isTemplateFrequencyManagementEligible,
    isIgnoreCapEditable: isTemplateFrequencyManaged,
  };
};
